import React, { useEffect, useState } from 'react';
import { hardRefresh } from '../utils/versionCheck';
import { isRunningInWebView } from '../utils/webviewCache';

const AppInitializationError = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if app is still white/blank after 5 seconds
    const timer = setTimeout(() => {
      const root = document.getElementById('root');
      if (!root || !root.innerHTML.trim()) {
        console.warn('App initialization timeout - showing recovery UI');
        setIsVisible(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  const inWebView = isRunningInWebView();

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 9999,
      backgroundColor: '#fff3cd',
      border: '2px solid #ffc107',
      borderRadius: '8px',
      padding: '16px',
      maxWidth: '300px',
      fontFamily: 'Poppins, sans-serif',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    }}>
      <h4 style={{ margin: '0 0 8px 0', color: '#333', fontSize: '14px' }}>
        App Loading Issue
      </h4>
      <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: '13px' }}>
        {inWebView
          ? 'The app is taking longer to load. This may be due to cached files in your app.'
          : 'The app is taking longer than expected to load. This may be due to cached files.'}
      </p>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            flex: 1,
            padding: '8px 12px',
            fontSize: '13px',
            backgroundColor: '#ffc107',
            color: '#000',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: '500'
          }}
        >
          Soft Refresh
        </button>
        <button
          onClick={hardRefresh}
          style={{
            flex: 1,
            padding: '8px 12px',
            fontSize: '13px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: '500'
          }}
        >
          Hard Refresh
        </button>
      </div>
    </div>
  );
};

export default AppInitializationError;
